import Comp from './Image'

export default Comp
